export class Option {
	id: number;
	value: string;
	name: string;
	data: string;
	references: string;
}
